import { useIsFeatureEnabled } from "src/common/hooks/useIsFeatureEnabled"

export function useIsGXAgentEnabled() {
  const isGxRunnerEnabled = useIsFeatureEnabled("gxRunnerEnabled")
  const hasOwnAgent = useIsFeatureEnabled("forceEnableAgent")

  return isGxRunnerEnabled ? hasOwnAgent : true
}
